/**
 * 学习乐园 · 排排序题材包：月相周期（paixu/pack-yuexiang.js）
 * ---------------------------------------------------------------------------
 * 月相按一个周期从新月到残月排（农历一个月的口径）。牌面是内联 SVG
 * 示意月相（亮面 #f0b429 / 暗面 #c9cdd4）——「几何可画」就画出来，
 * 排的是图形不是文字，辨认本身才是练习。
 * 口径：北半球观察者的习惯方向——上弦月右半亮、下弦月左半亮
 * （「上上上西西、下下下东东」的口诀里「右亮上弦」这半句），doc 页说明。
 * SVG 弧线说明：外弧 sweep=1 经过右侧、sweep=0 经过左侧；内弧（rx=11）
 * 决定亮面是否凸过半圆——凸月内弧凸向对侧，蛾眉/残月内弧同侧收窄。
 */
(function (global) {
  'use strict';
  var PACKS = global.STPX_PACKS = global.STPX_PACKS || {};

  function moonSvg(darkPath) {
    return '<svg viewBox="0 0 40 40" aria-hidden="true" focusable="false">'
      + '<circle cx="20" cy="20" r="16" fill="#c9cdd4"/>'
      + (darkPath ? '<path d="' + darkPath + '" fill="#f0b429"/>' : '')
      + '</svg>';
  }

  function faceHtml(face, litPath) {
    return moonSvg(litPath) + '<span class="st-px-face-text">' + face + '</span>';
  }

  PACKS.yuexiang = {
    id: 'yuexiang',
    name: '月相周期',
    hint: '从新月到残月排一圈',
    cols: 4,
    winText: '新月→娥眉→上弦→盈凸→满月→亏凸→下弦→残月，农历一个月正好一圈。',
    items: [
      { face: '新月', note: '月亮跑到地球和太阳中间，整晚看不见', html: faceHtml('新月', '') },
      { face: '娥眉月', note: '日落后西边天空中一弯细钩，钩口朝左（右亮）', html: faceHtml('娥眉月', 'M20 4 A16 16 0 0 1 20 36 A11 16 0 0 1 20 4 Z') },
      { face: '上弦月', note: '右半边亮，中午升起半夜落下', html: faceHtml('上弦月', 'M20 4 A16 16 0 0 1 20 36 Z') },
      { face: '盈凸月', note: '亮面超过一半，还在往满月「长」', html: faceHtml('盈凸月', 'M20 4 A16 16 0 0 1 20 36 A11 16 0 0 0 20 4 Z') },
      { face: '满月', note: '通宵都在天上，农历十五前后', html: faceHtml('满月', 'M20 4 A16 16 0 1 1 19.9 4 Z') },
      { face: '亏凸月', note: '亮面开始从右边「缩」，还剩大半', html: faceHtml('亏凸月', 'M20 4 A16 16 0 0 0 20 36 A11 16 0 0 1 20 4 Z') },
      { face: '下弦月', note: '左半边亮，半夜升起早上还在', html: faceHtml('下弦月', 'M20 4 A16 16 0 0 0 20 36 Z') },
      { face: '残月', note: '黎明前东边天空中一弯细钩（左亮）', html: faceHtml('残月', 'M20 4 A16 16 0 0 0 20 36 A11 16 0 0 0 20 4 Z') }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
